import React from 'react';
import PropTypes from 'prop-types';
import {
  ITEM_DISH_TYPE_HEIGHT,
  ITEM_DISH_HEIGHT,
  ITEM_DISH_DISCOUNT,
  ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP,
  BIG_ITEM_DISH_TYPE_HEIGHT,
  BIG_ITEM_DISH_HEIGHT,
  HUGE_ITEM_DISH_TYPE_HEIGHT,
  HUGE_ITEM_DISH_HEIGHT,
  TEA_ITEM_DISH_HEIGHT_BASIC,
  TEA_ITEM_DISH_HEIGHT_MEMBER,
  TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY,
  TEA_ITEM_DISH_DISCOUNT_HEIGHT,
} from './calcPosHelper';
import { DishTheme, INDUSTRY } from '../../helper/const.js';
import { getIndustryFromBody } from '@helper/industry-helper';

class RobotListBody extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    parentBodyHeight: PropTypes.number,
    getRobotInfo: PropTypes.func,
    isZc: PropTypes.bool,
    hasAds: PropTypes.bool,
  };

  static defaultProps = {
    children: null,
    parentBodyHeight: 0,
    getRobotInfo: () => {},
    isZc: false,
    hasAds: false,
  };

  constructor() {
    super();

    this.robotBody = null;
    this.state = {
      ulHeight: null,
    };
  }

  getNewScreenNum(robotNewTop) {
    const parentBodyHeight = this.props.parentBodyHeight;

    return Math.floor(robotNewTop / parentBodyHeight) + 1;
  }

  componentDidMount() {
    this.assembleInfo();
  }

  /**
   * 根据数据计算组装相关信息。
   * 为了尽可能的减少改动原代码。此处返回的数据与原返回数据一致。
   * 只不过，这些数据是通过计算而来。
   * 原来是通过渲染出来 再获取而已。
   */
  assembleInfo() {
    if (!this.robotBody) throw new Error('未查找到菜品容器DOM对象');
    const { offsetTop: pTop, offsetLeft: pLeft, offsetWidth: pWidth, offsetHeight: pHeight } = this.robotBody;

    const { dishTypesData, getRobotInfo, dishesData, parentBodyHeight, theme } = this.props;
    // 所有菜品和分类条目的坐标信息
    const locationGroup = {};
    // 用于保存条目的索引和屏数。之前这是个数组。但是对象应该更合理  看结构 id:[{}]
    const dishIndexList = {};

    // 分类条目信息
    const titleMarkInfo = {
      infoList: [],
      infoIndex: {},
    };
    let currentTop = pTop;
    dishTypesData.forEach((dishType, index) => {
      const { id: dishTypeId, dishIds, reactObj, dishAry } = dishType;

      let lastDishTypeTop = null;
      if (index === dishTypesData.length - 1) {
        lastDishTypeTop = currentTop;
      }

      const infoListLength = titleMarkInfo.infoList.length;

      titleMarkInfo.infoList[infoListLength] = {
        dishId: dishTypeId,
        top: currentTop,
        index,
      };

      const sNum = this.getNewScreenNum(currentTop);
      this.assembleLocationGroupInfo(locationGroup, currentTop, sNum, { width: '100%', left: 0, className: '*', dishId: dishTypeId, reactObj });
      currentTop += this.getDishTypeHeightByCalc(theme); // 累加分类高度

      let tempStorePrevHeight = 0; // 只有theme为big时使用。因为big一行有两个菜。
      // 遍历该分类下的所有菜品
      dishIds.forEach((dishId, dIndx) => {
        const { reactObj: dishReactObj } = dishAry[dIndx];
        const screenNum = this.getNewScreenNum(currentTop);
        this.assembleLocationGroupInfo(locationGroup, currentTop, screenNum, {
          width: theme === DishTheme.BIG ? '50%' : '100%',
          left: theme === DishTheme.BIG && dIndx % 2 !== 0 ? '50%' : 0,
          className: '*',
          dishId: `${dishTypeId}-${dishId}`,
          reactObj: dishReactObj,
        });
        if (!dishIndexList[dishId]) {
          dishIndexList[dishId] = [];
        }
        dishIndexList[dishId].push({
          index: locationGroup[screenNum].length - 1,
          screenNum,
        });
        let currentDishHeight = this.getDishHeightByCalc(theme, dishAry[dIndx]);
        if (theme === DishTheme.BIG) {
          if (dIndx % 2 === 0 && dishIds.length - 1 !== dIndx) {
            tempStorePrevHeight = currentDishHeight;
          } else {
            currentDishHeight = Math.max(tempStorePrevHeight, currentDishHeight);
            tempStorePrevHeight = 0;
            currentTop += currentDishHeight; // 累加商品高度(商品的折扣信息)
          }
        } else {
          currentTop += currentDishHeight; // 累加商品高度(商品的折扣信息)
        }
      });

      // 最后一个中类，发现其菜品不足排列满一个可视区域，则自动加上一定高度来撑开一个可视区域。
      if (lastDishTypeTop !== null && currentTop - lastDishTypeTop < parentBodyHeight) {
        currentTop = parentBodyHeight + lastDishTypeTop + 15;
      }
    });
    const accumulationHeight = currentTop - pTop;
    const screenTotalNum = Object.keys(locationGroup).length;
    this.setUlHeight(accumulationHeight);

    getRobotInfo({
      titleMarkInfo,
      collectInfoAll: {
        locationGroup,
        accumulationHeight,
        screenTotalNum,
        dishIndexList,
      },
    });
  }

  assembleLocationGroupInfo(locationGroup, currentTop, screenNum, { className, dishId, reactObj = null, width = '100%', left = 0 } = {}) {
    if (!locationGroup[screenNum]) {
      locationGroup[screenNum] = [];
    }
    const lgItem = locationGroup[screenNum];
    lgItem.push({
      className: reactObj.props.className,
      top: currentTop,
      left,
      width,
      dishId,
      robotId: dishId,
      screenNum,
      keys: dishId,
      robotObj: reactObj,
      index: lgItem.length - 1,
    });
  }
  /**
   * 通过不同的主题，计算获取分类的高度
   * @param {*} theme
   */
  getDishTypeHeightByCalc(theme) {
    if (theme === DishTheme.BIG) {
      return BIG_ITEM_DISH_TYPE_HEIGHT;
    } else if (theme === DishTheme.HUGE) {
      return HUGE_ITEM_DISH_TYPE_HEIGHT;
    }
    return ITEM_DISH_TYPE_HEIGHT;
  }

  /**
   * 通过不同的主题，计算商品的高度
   * @param {*} theme
   * @param {*} dish
   */
  getDishHeightByCalc(theme, dish = {}) {
    let res = 0;
    switch (theme) {
      case DishTheme.BIG:
        res = this.getHeightFromBig(dish);
        break;
      case DishTheme.HUGE:
        res = this.getHeightFromHuge(dish);
        break;
      case DishTheme.DEFAULT:
      default:
        res = this.getHeightFromDefault(dish);
    }

    return res;
  }

  /**
   * 默认模板 的 商品行高
   * @param {*} dish
   */
  getHeightFromDefault(dish) {
    let res = 0;
    const { isMember, isUserMember, marketingInfos, singleMarketingInfos } = dish;
    const { isHDL } = this.props;

    const industry = getIndustryFromBody() || INDUSTRY.NORMAL;

    const activityNum = isHDL
      ? Array.isArray(singleMarketingInfos) && !isMember
        ? Math.min(singleMarketingInfos.length, 1)
        : 0
      : Array.isArray(marketingInfos)
      ? Math.min(marketingInfos.length, 2)
      : 0;

    const getHeightByTea = () => {
      let result = 0;
      if (isMember && !isUserMember) {
        result = TEA_ITEM_DISH_HEIGHT_MEMBER;
      } else if (isMember && isUserMember) {
        result = TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY;
      } else {
        result = TEA_ITEM_DISH_HEIGHT_BASIC;
      }
      result += activityNum * TEA_ITEM_DISH_DISCOUNT_HEIGHT;
      return result;
    };

    const getHeightByNormal = () => ITEM_DISH_HEIGHT + ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP + activityNum * ITEM_DISH_DISCOUNT;

    switch (industry) {
      case INDUSTRY.TEA:
        res = getHeightByTea();
        break;
      case INDUSTRY.NORMAL:
      default:
        res = getHeightByNormal();
    }

    return res;
  }

  /**
   * 大图模板 的 商品行高
   * @param {*} dish
   */
  getHeightFromBig(dish) {
    return BIG_ITEM_DISH_HEIGHT;
  }

  /**
   * 巨图模板 的 商品行高
   * @param {*} dish
   */
  getHeightFromHuge(dish) {
    return HUGE_ITEM_DISH_HEIGHT;
  }

  setUlHeight(accumulationHeight) {
    this.setState({
      ulHeight: accumulationHeight,
    });
  }

  render() {
    const { children, isZc, hasAds } = this.props;
    const { ulHeight } = this.state;
    const height = document.body.clientHeight;
    const style = {
      width: '100%',
      whiteSpace: 'normal',
      height: ulHeight || 'auto',
    };
    if (hasAds && children && children.length < 5) {
      style.minHeight = `${height - (isZc ? 80 : 125)}px`;
    }
    return (
      <ul
        className="dish-list clearfix"
        style={style}
        ref={element => (this.robotBody = element)}
      >
        {children}
      </ul>
    );
  }
}

export default RobotListBody;



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/robotListBody.jsx